<template>
  <div>
    <v-dialog width="500" v-model="apgarScoreShow" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <span class="modal-title-text mr-2">نمره آپگار</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="6">
              <v-autocomplete :items="heartRateTypeList" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="ضربان قلب"
                :autofocus="true" v-model="apgar_heartRate" autocomplete="off"
                prepend-inner-icon="mdi-heart-pulse mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="tonicityTypeList" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="تونیسیته عضلات"
                v-model="apgar_tonicity" autocomplete="off" prepend-inner-icon="mdi-arm-flex mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="breathingTypeList" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="تنفس"
                v-model="apgar_breathing" autocomplete="off"
                prepend-inner-icon="mdi-gas-cylinder mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete :items="reactionTypeList" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="واکنش به تحریک"
                v-model="apgar_reaction" autocomplete="off"
                prepend-inner-icon="mdi-human-baby-changing-table mdi-18px"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-autocomplete :items="colorBodyTypeList" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense outlined
                clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="رنگ بدن"
                v-model="apgar_colorBody" autocomplete="off" prepend-inner-icon="mdi-baby mdi-18px"></v-autocomplete>
            </v-col>

          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="confirmApgarDialog()" dark rounded class="normal-letter-spacing px-12">
            تایید
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelApgarDialog()" class="normal-letter-spacing px-10">
            لغو
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row class="mt-16">
          <span>نوع ماموریت * </span>
          <v-divider class="mt-3 mr-3"></v-divider>
        </v-row>
        <v-row class="mt-8">
          <v-chip label color="darkColor" dark v-if="isDriveTroma == true">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            ترومایی مرتبط با حمل و نقل
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(1)">
            ترومایی مرتبط با حمل و نقل
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip label dark color="darkColor" v-if="isNotDrivingTroma">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            ترومایی / حادثه غیرمرتبط با حمل و نقل
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(2)">
            ترومایی / حادثه غیرمرتبط با حمل و نقل
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip label dark color="darkColor" v-if="isBrain">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            سکته مغزی
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(3)">
            سکته مغزی
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip label dark color="darkColor" v-if="isHeart">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            مشکلات قلبی
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(4)">
            مشکلات قلبی
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip label dark color="darkColor" v-if="isParturition">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            زایمان
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(6)">
            زایمان
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip label dark color="darkColor" v-if="isIllness">
            <v-icon color="white">mdi-check mdi-18px</v-icon>
            سایر بیماری ها
          </v-chip>
          <v-chip label outlined color="darkColor" v-else @click="missionTypeChange(5)">
            سایر بیماری ها
          </v-chip>
          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <v-col cols="12" class="mt-8">
            <v-row v-if="missionType == 2 || missionType == 1">
              <span>اطلاعات تکمیلی</span>
              <v-divider class="mt-3 mr-3"></v-divider>
            </v-row>
            <v-row v-if="missionType == 1">
              <v-col cols="4">
                <v-autocomplete :items="transitTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع تردد *" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.patientTraumaDetail.transitType"
                  autocomplete="off" prepend-inner-icon="mdi-road-variant mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <v-autocomplete :items="vehicleTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع وسیله نقلیه *" @change="vehicleTypeChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.patientTraumaDetail.vehicleType"
                  autocomplete="off" prepend-inner-icon="mdi-car mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.patientTraumaDetail.vehicleType == 'سایر'">
                <v-text-field dense outlined v-model="vehicleTypeOther" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-autocomplete :items="patientStateList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="وضعیت مصدوم *" @change="patientStateChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.patientTraumaDetail.patientState"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.patientTraumaDetail.patientState == 'سایر'">
                <v-text-field dense outlined v-model="patientStateOther" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4"
                v-if="patientDetail.patientTraumaDetail.vehicleType !== 'موتور سیکلت' && patientDetail.patientTraumaDetail.vehicleType !== 'دوچرخه'">
                <app-plate-field :default-val="patientDetail.patientTraumaDetail.vehiclePlateNumber"
                  v-model="patientDetail.patientTraumaDetail.vehiclePlateNumber" />
              </v-col>
              <v-col cols="4" v-if="patientDetail.patientTraumaDetail.vehicleType == 'موتور سیکلت'">
                <app-plate-field-motor :default-val="patientDetail.patientTraumaDetail.vehiclePlateNumber"
                  v-model="patientDetail.patientTraumaDetail.vehiclePlateNumber" />
              </v-col>
              <v-col cols="4">
                <v-text-field number dense outlined v-model="patientDetail.patientTraumaDetail.policeCode"
                  label="کد کروکی پلیس" clearable clear-icon="mdi-close-circle-outline"
                  prepend-inner-icon="mdi-text-box mdi-18px"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="missionType == 1">
              <v-col cols="6">
                <v-row>
                  <span>عملیات رهاسازی بیمار *</span>
                  <v-divider class="mt-3 mr-3 ml-3"></v-divider>
                </v-row>
              </v-col>
              <v-col cols="6">
                <v-row>
                  <span>توانایی حرکت</span>
                  <v-divider class="mt-3 mr-3"></v-divider>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="missionType == 1">
              <v-col cols="6">
                <v-row>
                  <span class="mt-6 info-text">رها سازی بیمار *</span>
                  <v-spacer></v-spacer>
                  <v-radio-group v-model="release" row>
                    <v-radio label="قبل از رسیدن تکنسین" value="before" class="ml-3"></v-radio>
                    <v-radio label="در حضور تکنسین" value="after"></v-radio>
                  </v-radio-group>
                  <v-col cols="1"></v-col>
                </v-row>
              </v-col>
              <v-col cols="6" class="mt-n3">
                <v-row>
                  <v-col cols="3">
                    <v-checkbox v-model="patientDetail.patientMovementAbility.rightHand" label="دست راست"></v-checkbox>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox v-model="patientDetail.patientMovementAbility.leftHand" label="دست چپ"></v-checkbox>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox v-model="patientDetail.patientMovementAbility.rightLeg" label="پای راست"></v-checkbox>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox v-model="patientDetail.patientMovementAbility.leftLeg" label="پای چپ"></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="missionType == 2">
              <v-col cols="4">
                <v-autocomplete :items="accidentTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع حادثه *" clearable
                  clear-icon="mdi-close-circle-outline" @change="accidentTypeChange()" v-model="patientDetail.diagnosis"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'سقوط'">
                <v-autocomplete :items="fallTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع سقوط *" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>

              <v-col cols="4" v-if="patientDetail.diagnosisDetail === 'سقوط غیر همتراز'">
                <v-text-field dense outlined @keypress="isNumber($event)" v-model="patientDetail.fallHeight"
                  label="ارتفاع سقوط *" clearable clear-icon="mdi-close-circle-outline"
                  prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'آلرژی'">
                <v-autocomplete :items="allergyList" no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title"
                  item-value="value" label="نوع آلرژی *" @change="diagnosisDetailChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'گزش حشرات و خزندگان و گیاهان سمی'">
                <v-autocomplete :items="biteTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع گزش *" @change="diagnosisDetailChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="
                patientDetail.diagnosis == 'گزش حشرات و خزندگان و گیاهان سمی' && patientDetail.diagnosisDetail == 'سایر'
              ">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'سوختگی'">
                <v-autocomplete :items="burnTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع سوختگی *" @change="diagnosisDetailChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="
                patientDetail.diagnosis == 'سوختگی' && patientDetail.diagnosisDetail == 'سایر'
              ">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'مسمومیت'">
                <v-autocomplete :items="poisoningTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع مسمومیت *" @change="diagnosisDetailChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="
                patientDetail.diagnosis == 'مسمومیت' && patientDetail.diagnosisDetail == 'سایر'
              ">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'حوادث عمدی'">
                <v-autocomplete :items="deliberateAccidentTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع حادثه عمدی *" @change="diagnosisDetailChange()"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="
                patientDetail.diagnosis == 'حوادث عمدی' && patientDetail.diagnosisDetail == 'سایر'
              ">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="missionType == 3 || missionType == 4 || missionType == 5">
              <span>تشخیص</span>
              <v-divider class="mt-3 mr-3"></v-divider>
            </v-row>
            <v-row v-if="missionType == 3">
              <v-col cols="4">
                <v-autocomplete :items="brainDiagnosisTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="تشخیص *" @change="diagnosisDetailChange()" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosisDetail == 'سایر'">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else-if="missionType == 4">
              <v-col cols="4">
                <v-autocomplete :items="heartDiagnosisTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" @change="diagnosisDetailChange()" label="تشخیص *" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosisDetail == 'سایر'">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
            </v-row>
            <v-row v-else-if="missionType == 5">
              <v-col cols="4">
                <v-autocomplete :items="illnessDiagnosisTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" @change="diagnosisChange()" label="تشخیص *" clearable
                  clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosis" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اورژانس های تنفسی'">
                <v-autocomplete :items="respiratoryEmergencyTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع اورژانس تنفسی *" @change="diagnosisDetailChange()"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اورژانس های دیابت'">
                <v-autocomplete :items="diabetesEmergencyTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع اورژانس دیابت *" clearable
                  @change="diagnosisDetailChange()" clear-icon="mdi-close-circle-outline"
                  v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اورژانس های رفتاری'">
                <v-autocomplete :items="behavioralEmergencyTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع اورژانس رفتاری *" @change="diagnosisDetailChange()"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اختلالات نورولوژیک به غیر از CVA'">
                <v-autocomplete :items="neurologicalEmergencyTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" label="نوع اختلالات نورولوژیک *"
                  @change="diagnosisDetailChange()" clearable clear-icon="mdi-close-circle-outline"
                  v-model="patientDetail.diagnosisDetail" autocomplete="off"
                  prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <!-- <v-col cols="4" v-if="patientDetail.diagnosis == 'بیماری های عفونی'">
                <v-autocomplete :items="infectiousDiseasesTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" @change="diagnosisDetailChange()" label="نوع بیماری عفونی"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col> -->
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اورژانس های جراحی'">
                <v-autocomplete :items="surgicalEmergencyTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" item-value="value" @change="diagnosisDetailChange()" label="نوع اورژانس جراحی *"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'اورژانس های زنان'">
                <v-autocomplete :items="WomenEmergencTypeList" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                  item-text="title" @change="diagnosisDetailChange()" item-value="value" label="نوع اورژانس زنان *"
                  clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                  autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
              </v-col>
              <v-col cols="4" v-if="patientDetail.diagnosis == 'سایر'">
                <v-text-field dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *" clearable
                  clear-icon="mdi-close-circle-outline" prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
              </v-col>
            </v-row>
            <template v-else-if="missionType == 6">
              <v-row>

                <v-col cols="12" class="">
                  <div class="dividerBox">
                    <span class="txtTitle">تشخیص و تاریخچه پزشکی</span>
                    <div class="divider"></div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <v-autocomplete :items="parturitionDiagnosisTypeList" no-data-text="اطلاعاتی وجود ندارد" dense
                    outlined item-text="title" @change="diagnosisDetailChange()" item-value="value" label="تشخیص *"
                    clearable clear-icon="mdi-close-circle-outline" v-model="patientDetail.diagnosisDetail"
                    autocomplete="off" prepend-inner-icon="mdi-account-injury mdi-18px"></v-autocomplete>
                </v-col>
                <v-col cols="4" v-if="patientDetail.diagnosisDetail == 'سایر'">
                  <v-text-field hide-details dense outlined v-model="otherDiagnosisDetail" label="سایر با ذکر نام *"
                    clearable clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-text mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="4" class="">
                  <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                    v-model="patientDetail.patientParturitionDetail.numberOfParturition" label="تعداد بارداری" clearable
                    clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-account-child mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="4" class="">
                  <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                    v-model="patientDetail.patientParturitionDetail.numberOfSuccessfulParturition"
                    label="تعداد زایمان موفق" clearable clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-human-pregnant mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="4" class="">
                  <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                    v-model="patientDetail.patientParturitionDetail.numberOfMiscarriage" label="تعداد سقط" clearable
                    clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-file-document mdi-18px"></v-text-field>
                </v-col>
                <v-col cols="4" class="">
                  <v-text-field hide-details dense outlined @keypress="isNumber($event)"
                    v-model="patientDetail.patientParturitionDetail.pregnancyAge" label="سن بارداری(هفته)" clearable
                    clear-icon="mdi-close-circle-outline"
                    prepend-inner-icon="mdi-file-document mdi-18px"></v-text-field>
                </v-col>

                <v-col cols="12" class="">
                  <div class="dividerBox">
                    <span class="txtTitle">وضعیت زایمان</span>
                    <div class="divider"></div>
                  </div>
                </v-col>

                <v-col cols="4" class="mb-4">
                  <v-row>
                    <span class="mt-6 info-text mr-3">زایمان انجام شده است ؟ *</span>
                    <v-spacer></v-spacer>
                    <v-radio-group hide-details v-model="patientDetail.patientParturitionDetail.hasParturitionDone" row>
                      <v-radio label="بلی" :value="true"></v-radio>
                      <v-radio label="خیر" :value="false"></v-radio>
                    </v-radio-group>
                    <v-col cols="1"></v-col>
                  </v-row>
                </v-col>

                <template v-if="patientDetail.patientParturitionDetail.hasParturitionDone">
                  <v-col cols="4" class="">
                    <v-row>
                      <span class="mt-6 info-text mr-3"> زمان زایمان : *</span>
                      <v-spacer></v-spacer>
                      <v-radio-group hide-details v-model="patientDetail.patientParturitionDetail.beforeCodeArrival"
                        row>
                        <v-radio label="قبل از رسیدن کد" :value="true"></v-radio>
                        <v-radio label="بعد از رسیدن کد" :value="false"></v-radio>
                      </v-radio-group>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4" class="">
                    <v-row>
                      <span class="mt-6 info-text mr-3">خروج جفت : *</span>
                      <v-spacer></v-spacer>
                      <v-radio-group hide-details v-model="fetalPlacentaOutBabies" row>
                        <v-radio label="بلی" :value="true" class="ml-2"></v-radio>
                        <v-radio label="خیر" :value="false"></v-radio>
                      </v-radio-group>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" class="">
                    <div class="dividerBox">
                      <span class="txtTitle">جزئیات زایمان *</span>
                      <div class="divider"></div>
                    </div>
                  </v-col>
                  <v-col cols="4" class="">
                    <v-text-field hide-details type="text" outlined id="user-moveFromStationTime"
                      ref="moveFromStationTime" dense clearable autocomplete="off"
                      @click:clear="clearDateTime('parturitionDate')" clear-icon="mdi-close-circle-outline"
                      v-model="tempParturitionDate" @focus="showParturitionDate = true"
                      @click="showParturitionDate = true" label="زمان دقیق زایمان *"
                      prepend-inner-icon="mdi-calendar-range mdi-18px">
                      <template slot="append">
                        <v-icon @click="showParturitionDate = true" class="calender-background ml-n3 mt-n2"
                          color="white">
                          mdi-calendar-range mdi-18px
                        </v-icon>
                      </template>
                    </v-text-field>
                    <date-picker :show="showParturitionDate" simple v-model="parturitionDateBabies" type="time"
                      @open="onOpen" @change="dateTimeChange('parturitionDate')" :editable="true" format="HH:mm"
                      display-format="HH:mm" custom-input="#moveFromStationTime-moveFromStationTime"
                      @close="showParturitionDate = false" />
                  </v-col>
                  <v-col cols="4">
                    <v-autocomplete hide-details :items="childTypeList" no-data-text="اطلاعاتی وجود ندارد" dense
                      outlined item-text="title" item-value="value" label="جنسیت *" clearable
                      clear-icon="mdi-close-circle-outline" v-model="genderBabies" autocomplete="off"
                      prepend-inner-icon="mdi-gender-male-female mdi-18px"></v-autocomplete>
                  </v-col>

                  <v-col cols="4">
                    <v-autocomplete hide-details :items="parturitionFetalPositionTypeList"
                      no-data-text="اطلاعاتی وجود ندارد" dense outlined item-text="title" item-value="value"
                      label="نمای زایمان *" clearable clear-icon="mdi-close-circle-outline"
                      v-model="fetalPositionIdBabies" autocomplete="off"
                      prepend-inner-icon="mdi-human-pregnant mdi-18px"></v-autocomplete>
                  </v-col>


                  <!-- <v-col cols="4" class="">
                    <v-row>
                      <span class="mt-6 info-text mr-3">چندقلویی</span>
                      <v-spacer></v-spacer>
                      <v-radio-group hide-details v-model="patientDetail.patientParturitionDetail.isMultiple" row>
                        <v-radio label="دارد" :value="true" class="ml-4"></v-radio>
                        <v-radio label="ندارد" :value="false"></v-radio>
                      </v-radio-group>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </v-col> -->

                  <!-- <v-col cols="4" class="">
                    <v-row>
                      <span class="mt-6 info-text mr-3">خونریزی واژینال</span>
                      <v-spacer></v-spacer>
                      <v-radio-group hide-details v-model="patientDetail.patientParturitionDetail.isVaginalBleeding"
                        row>
                        <v-radio label="بلی" :value="true" class="ml-2"></v-radio>
                        <v-radio label="خیر" :value="false"></v-radio>
                      </v-radio-group>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </v-col> -->
                  <!-- <v-col cols="4" class=""></v-col> -->

                  <v-col cols="4" class="mt-4">
                    <div class="dividerBox">
                      <span class="txtTitle">آپگار هنگام تولد * </span>
                      <div class="divider"></div>
                    </div>
                  </v-col>
                  <v-col cols="4" class="mt-4">
                    <div class="dividerBox">
                      <span class="txtTitle">آپگار ده دقیقه بعد از تولد * </span>
                      <div class="divider"></div>
                    </div>
                  </v-col>
                  <v-col cols="4" class="mt-4">
                    <div class="dividerBox">
                      <span class="txtTitle">آپگار هنگام تحویل * </span>
                      <div class="divider"></div>
                    </div>
                  </v-col>

                  <v-col cols="4">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field hide-details type="text" outlined dense clearable autocomplete="off"
                          @click:clear="clearDateTime('parturitionDateApgar1')" clear-icon="mdi-close-circle-outline"
                          v-model="tempParturitionDateApgar1" @focus="showParturitionDateApgar1 = true"
                          @click="showParturitionDateApgar1 = true" label="زمان "
                          prepend-inner-icon="mdi-calendar-range mdi-18px">
                          <template slot="append">
                            <v-icon @click="showParturitionDateApgar1 = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :show="showParturitionDateApgar1" simple v-model="parturitionDateBabiesApgar1"
                          type="time" @open="onOpen" @change="dateTimeChange('parturitionDateApgar1')" :editable="true"
                          format="HH:mm" display-format="HH:mm" custom-input="#moveFromStationTime-moveFromStationTime"
                          @close="showParturitionDateApgar1 = false" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined v-model="scoreApgar1" label="نمره آپگار"
                          @click="showDilaogApgar(1)" readonly prepend-inner-icon="mdi-file-document mdi-18px" />
                      </v-col>
                    </v-row>

                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field hide-details type="text" outlined dense clearable autocomplete="off"
                          @click:clear="clearDateTime('parturitionDateApgar2')" clear-icon="mdi-close-circle-outline"
                          v-model="tempParturitionDateApgar2" @focus="showParturitionDateApgar2 = true"
                          @click="showParturitionDateApgar2 = true" label="زمان "
                          prepend-inner-icon="mdi-calendar-range mdi-18px">
                          <template slot="append">
                            <v-icon @click="showParturitionDateApgar2 = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :show="showParturitionDateApgar2" simple v-model="parturitionDateBabiesApgar2"
                          type="time" @open="onOpen" @change="dateTimeChange('parturitionDateApgar2')" :editable="true"
                          format="HH:mm" display-format="HH:mm" custom-input="#moveFromStationTime-moveFromStationTime"
                          @close="showParturitionDateApgar2 = false" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined v-model="scoreApgar2" label="نمره آپگار"
                          @click="showDilaogApgar(2)" readonly prepend-inner-icon="mdi-file-document mdi-18px" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4">
                    <v-row>
                      <v-col cols="6">
                        <v-text-field hide-details type="text" outlined dense clearable autocomplete="off"
                          @click:clear="clearDateTime('parturitionDateApgar3')" clear-icon="mdi-close-circle-outline"
                          v-model="tempParturitionDateApgar3" @focus="showParturitionDateApgar3 = true"
                          @click="showParturitionDateApgar3 = true" label="زمان "
                          prepend-inner-icon="mdi-calendar-range mdi-18px">
                          <template slot="append">
                            <v-icon @click="showParturitionDateApgar3 = true" class="calender-background ml-n3 mt-n2"
                              color="white">
                              mdi-calendar-range mdi-18px
                            </v-icon>
                          </template>
                        </v-text-field>
                        <date-picker :show="showParturitionDateApgar3" simple v-model="parturitionDateBabiesApgar3"
                          type="time" @open="onOpen" @change="dateTimeChange('parturitionDateApgar3')" :editable="true"
                          format="HH:mm" display-format="HH:mm" custom-input="#moveFromStationTime-moveFromStationTime"
                          @close="showParturitionDateApgar3 = false" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field hide-details dense outlined v-model="scoreApgar3" label="نمره آپگار"
                          @click="showDilaogApgar(3)" readonly prepend-inner-icon="mdi-file-document mdi-18px" />
                      </v-col>
                    </v-row>
                  </v-col>
                </template>

              </v-row>
            </template>
          </v-col>
        </v-row>
        <v-row v-if="missionType" class="mt-6">
          <v-spacer></v-spacer>
          <v-btn rounded color="darkColor" dark @click="goToStep4()">ثبت و بعدی</v-btn>
          <v-btn text color="darkColor" @click="backToStep2()">قبلی</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AppPlateField from '@/components/app/plateField.vue';
import AppPlateFieldMotor from '@/components/app/plateFieldMotor.vue';
import FollowUpPatientStep3Helper from '@/Helpers/FollowUp/FollowUpPatientPart/FollowUpPatientStep3Helper.js';
import SharedHelper from '@/Helpers/Shared';
import SharedMixin from '@/Mixins/Shared';
import PatientDetailMixin from '@/Mixins/FollowUp/FollowUpPatientPart/PatientDetailMixin.js';
export default {
  mixins: [FollowUpPatientStep3Helper, SharedHelper, SharedMixin, PatientDetailMixin],
  components: { AppPlateField, AppPlateFieldMotor },
  mounted() {
    this.mounteLoding();
  },
  props: {
    patientId: {
      type: Number,
      require: true,
      default: null,
    },
  },
  data() {
    return {
      apgarScoreShow: false,
      apgarType: null,
      apgar_colorBody: null,
      apgar_reaction: null,
      apgar_breathing: null,
      apgar_heartRate: null,
      apgar_tonicity: null,
    };
  },
  computed: {
    fetalPlacentaOutBabies: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          return babies[0]?.isFetalPlacentaOut;
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0 && babies[0]) {
          babies[0].isFetalPlacentaOut = value;
        }
      },
    },
    parturitionDateBabies: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          return babies[0]?.parturitionDate;
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0 && babies[0]) {
          babies[0].parturitionDate = value;
        }
      },
    },
    fetalPositionIdBabies: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          return babies[0]?.fetalPositionId;
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0 && babies[0]) {
          babies[0].fetalPositionId = value;
        }
      },
    },
    genderBabies: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          return babies[0]?.gender;
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0 && babies[0]) {
          babies[0].gender = value;
        }
      },
    },
    parturitionDateBabiesApgar1: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 0) {
            return apgarDetails[0]?.timeInSeconds;
          }
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 0 && apgarDetails[0]) {
            apgarDetails[0].timeInSeconds = value;
          }
        }
      },
    },
    parturitionDateBabiesApgar2: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 1) {
            return apgarDetails[1]?.timeInSeconds;
          }
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 1 && apgarDetails[1]) {
            apgarDetails[1].timeInSeconds = value;
          }
        }
      },
    },
    parturitionDateBabiesApgar3: {
      get() {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 2) {
            return apgarDetails[2]?.timeInSeconds;
          }
        }
        return null;
      },
      set(value) {
        const babies = this.patientDetail?.patientParturitionBabies;
        if (babies && babies.length > 0) {
          const apgarDetails = babies[0]?.patientApgarDetails;
          if (apgarDetails && apgarDetails.length > 2 && apgarDetails[2]) {
            apgarDetails[2].timeInSeconds = value;
          }
        }
      },
    },
  },
  methods: {
    mounte: function () {
      this.getPatientDetailByFollowupFunction(this.patientId);
    },
    resetDetailApgar() {
      this.apgarType = null;
      this.apgar_colorBody = null;
      this.apgar_reaction = null;
      this.apgar_breathing = null;
      this.apgar_heartRate = null;
      this.apgar_tonicity = null;
    },
    showDilaogApgar(type) {
      this.resetDetailApgar()
      this.apgarScoreShow = true;
      this.apgarType = type;
    },
    confirmApgarDialog() {
      if (
        this.apgar_colorBody == null ||
        this.apgar_reaction == null ||
        this.apgar_breathing == null ||
        this.apgar_heartRate == null ||
        this.apgar_tonicity == null
      ) {
        this.showErrorAlert('همه مقادیر باید پر شود');
        return
      }
      try {
        this.patientDetail.patientParturitionBabies[0].patientApgarDetails[this.apgarType - 1].heartBeatId = this.apgar_heartRate
        this.patientDetail.patientParturitionBabies[0].patientApgarDetails[this.apgarType - 1].muscleToneId = this.apgar_tonicity
        this.patientDetail.patientParturitionBabies[0].patientApgarDetails[this.apgarType - 1].babyRespirationId = this.apgar_breathing
        this.patientDetail.patientParturitionBabies[0].patientApgarDetails[this.apgarType - 1].babyReactionToStimulationId = this.apgar_reaction
        this.patientDetail.patientParturitionBabies[0].patientApgarDetails[this.apgarType - 1].babyBodyColorId = this.apgar_colorBody

        let sumNum = 0
        sumNum += this.apgar_heartRate - 1
        sumNum += this.apgar_tonicity - 1
        sumNum += this.apgar_breathing - 1
        sumNum += this.apgar_reaction - 1
        sumNum += this.apgar_colorBody - 1

        if (this.apgarType == 1) {
          this.scoreApgar1 = sumNum
        }
        if (this.apgarType == 2) {
          this.scoreApgar2 = sumNum
        }
        if (this.apgarType == 3) {
          this.scoreApgar3 = sumNum
        }

        this.cancelApgarDialog()

      } catch (error) {
        console.log("AA : error : ", error);
      }
    },
    cancelApgarDialog() {
      this.resetDetailApgar()
      this.apgarScoreShow = false;
    }
  },
};
</script>
<style scoped>
.dividerBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
}

.dividerBox .txtTitle {
  font-size: 14px;
  font-weight: 500;
  color: #898989;
  white-space: nowrap;
}

.dividerBox .divider {
  flex: 1;
  height: 1px;
  background: #dbdbdb;
}

.info-text {
  color: #212121 !important;
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}
</style>
